import script from "./FrequentView.vue?vue&type=script&setup=true&lang=js"
export * from "./FrequentView.vue?vue&type=script&setup=true&lang=js"

import "./FrequentView.vue?vue&type=style&index=0&id=51d79760&lang=css"

const __exports__ = script;

export default __exports__